import React from 'react';

import { useExportGridPA } from 'scenes/CustomAudiences/PartnerAudiences/data/mutations';

import {
  Action,
  Actions,
  ActionBar,
  FileDownloadIcon,
  ViewColumnIcon,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useChildComponent } from '@gogame/hooks-ts';
import {
  SearchField,
  useScreenDispatch,
  useScreenState,
  useScreenTitle,
} from '@gogame/screens';
import { PartnerAudienceFormCreate } from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm';
import PartnerAudienceColumnPicker from './PartnerAudienceColumnPicker';
import { SET_COLUMNS } from 'scenes/CustomAudiences/PartnerAudiences/screenReducer';
import { PERMISSION_GRID_EXPORT } from 'scenes/CustomAudiences/PartnerAudiences/constants';
import { useIsAllowed } from '@gogame/permissions';

export default () => {
  const [title] = useScreenTitle();
  const dispatch = useScreenDispatch();
  const isAllowed = useIsAllowed();
  const screenState = useScreenState();
  const [childComponent, openChildComponent] = useChildComponent();
  const [exportTable] = useExportGridPA();

  const handleCreate = () => {
    openChildComponent(PartnerAudienceFormCreate);
  };

  const handleExport = () => {
    exportTable({
      filters: screenState.filters,
      search: screenState.searchQuery,
      ...screenState.tableSettings,
    });
  };
  const handleCustomizeColumn = () => {
    openChildComponent(PartnerAudienceColumnPicker, {
      value: screenState.columns.order,
      onSubmit: ({ order }) => {
        const action = {
          type: SET_COLUMNS,
          payload: {
            collapsed: screenState.columns.collapsed,
            order,
          },
        };
        dispatch(action);
      },
    });
  };

  return (
    <React.Fragment>
      <ActionBar
        title={title}
        search={<SearchField tooltip={'Search by name, partner or id'} />}
        primaryActions={
          <Actions>
            {isAllowed(PERMISSION_GRID_EXPORT) && (
              <Action
                icon={<FileDownloadIcon />}
                label={'Export Partner Audiences'}
                onClick={handleExport}
              />
            )}
            <Action
              icon={<ViewColumnIcon />}
              label={'Customize columns'}
              onClick={handleCustomizeColumn}
            />
            <Action component={FullScreenToggler} />
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add Partner Audiences'}
              variant={'outlined'}
              onClick={handleCreate}
            />
          </Actions>
        }
      />
      {childComponent}
    </React.Fragment>
  );
};
